import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import iconTypes from './iconTypes';
import './Icon.scss';
var ARTBOARD_SIZE = 32;
var IconSizes = {
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small'
};
export var IconColors = {
    BLACK: 'black',
    BLUE: 'blue',
    GRAY: 'gray',
    WHITE: 'white',
    PURPLE: 'purple'
};
export var IconBgColors = {
    GRAY: 'gray',
    GREEN: 'green',
    RED: 'red',
    WHITE: 'white',
    YELLOW: 'yellow'
};
var Icon = function (_a) {
    var _b, _c;
    var backgroundColor = _a.backgroundColor, className = _a.className, color = _a.color, size = _a.size, title = _a.title, type = _a.type, props = __rest(_a, ["backgroundColor", "className", "color", "size", "title", "type"]);
    var _d = iconTypes[type], content = _d.content, defaultTitle = _d.title;
    var hasBackground = Boolean(backgroundColor);
    var iconClassName = classnames('Icon', "Icon--".concat(size), (_b = {},
        _b["Icon--".concat(color)] = Object.values(IconColors).includes(color),
        _b), className, (_c = {
            'Icon--hasBackground': hasBackground
        },
        _c["Icon--".concat(backgroundColor, "Background")] = hasBackground,
        _c));
    return (React.createElement("div", __assign({}, props, { className: iconClassName }),
        React.createElement("svg", { "aria-label": title !== null && title !== void 0 ? title : defaultTitle, className: 'Icon__svg', role: 'img', viewBox: "0 0 ".concat(ARTBOARD_SIZE, " ").concat(ARTBOARD_SIZE), xmlns: 'http://www.w3.org/2000/svg' }, content)));
};
Icon.defaultProps = {
    color: IconColors.GRAY,
    size: IconSizes.MEDIUM
};
export default Icon;
//# sourceMappingURL=Icon.js.map